/**
 * Approval decisions (WS Z, approvals review): what a reviewer reads when a decision is refused because the video
 * changed (`version_conflict`) or someone else decided first (`stage_conflict`), as [English, Hebrew]. The
 * `version_conflict` text is generic on purpose: ErrorBox shows it for any 409 `version_conflict` (cuts, renders too). Kept apart from
 * the main table (00-common: new strings go to a sub-module). Same rules as strings.ts: the same placeholders in both
 * languages, Hebrew in every Hebrew value. Import from `@castfeeds/i18n/decisions`.
 */
import { interpolate, type Locale, type Vars } from './index.js';

export const decisionStrings = {
  decVersionConflict: [
    'This video changed since you looked at it (it is now version {version}). Reload to see the new version, then try again.',
    'הסרטון השתנה מאז שצפיתם בו (עכשיו זו גרסה {version}). טענו מחדש כדי לראות את הגרסה החדשה, ונסו שוב.',
  ],
  decStageConflict: [
    'Someone else decided on this video while you were looking. Reload to see where it is now.',
    'מישהו אחר החליט על הסרטון בזמן שצפיתם בו. טענו מחדש כדי לראות איפה הוא עומד.',
  ],
} as const satisfies Record<string, readonly [string, string]>;

export type DecisionKey = keyof typeof decisionStrings;
export type DecisionT = (key: DecisionKey, vars?: Vars) => string;

/** t() for the approval-decision messages. */
export function decisionT(locale: Locale): DecisionT {
  const i = locale === 'he' ? 1 : 0;
  return (key, vars) => interpolate(decisionStrings[key][i], vars);
}
